export const extractSecretKey = (data) => {
  const explodedData = data.split("+");
  const [part_1_len, part_1, part_2_len, data_length, ...other] = explodedData;
  const part_2 = data.split("").splice(-parseInt(part_2_len, 10)).join("");
  const otherData = other.join("+");
  const originalData = otherData.slice(0, parseInt(data_length, 10));
  return { key: part_1 + part_2, originalData };
};
